import { Component } from '@angular/core';
import { LoadingService } from './core/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
   standalone: false
})
export class AppComponent {
  title = 'velzon';
  loading$ = this.loadingService.loading$;

  constructor(private loadingService: LoadingService) {}
}
